import { render, staticRenderFns } from "./ChatCorrespondenceUnseenButton.vue?vue&type=template&id=da84dae0&scoped=true&"
import script from "./ChatCorrespondenceUnseenButton.vue?vue&type=script&lang=js&"
export * from "./ChatCorrespondenceUnseenButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatCorrespondenceUnseenButton.vue?vue&type=style&index=0&id=da84dae0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da84dae0",
  null
  
)

export default component.exports